/**
 * Check a domain entitlement for the presence of a skipped domain
 *
 * @param {object} entitlement
 * @returns {boolean}
 */
export const hasSkippedDomain = (entitlement) => (
  entitlement?.fulfillment?.orderTaskStatus === 'declined'
  || (
    entitlement?.fulfillment?.orderTaskStatus === 'pending'
    && entitlement?.fulfillment?.orderTaskData?.skip === true
  )
);
